const state = {
    collectDataForBopUser: {

    },
    collectDataSubTitle: ""
}
const getters = {

}
const mutations = {
    updateCollectionDataBopUser(state, payload) {
        state.collectDataForBopUser = payload;
    },

    updateCollectDataSubTitle(state, collectDataSubTitle) {
        state.collectDataSubTitle = collectDataSubTitle
    }
}
const actions = {
    commitCollectDataSubTitle({ commit }, data) {
        commit('updateCollectDataSubTitle', data);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}